const STORAGE_PREFIX = 'prairi.dashboardWelcomeVisit.';

/** Six calendar months, matching “hasn’t opened the dashboard for the last 6 months”. */
export function dashboardWelcomeIsDue(lastVisitIso: string | null, now = new Date()): boolean {
  if (!lastVisitIso) return true;
  const last = new Date(lastVisitIso);
  if (Number.isNaN(last.getTime())) return true;
  const cutoff = new Date(now);
  cutoff.setMonth(cutoff.getMonth() - 6);
  return last.getTime() <= cutoff.getTime();
}

export function readDashboardWelcomeVisit(userId: string): string | null {
  try {
    return window.localStorage.getItem(`${STORAGE_PREFIX}${userId}`);
  } catch {
    return null;
  }
}

export function recordDashboardWelcomeVisit(userId: string, now = new Date()): void {
  try {
    window.localStorage.setItem(`${STORAGE_PREFIX}${userId}`, now.toISOString());
  } catch {
    // Private mode can block storage. The callout still closes for this view.
  }
}
